import React, { useContext } from "react";
import { FlowType } from "../../constants/FlowType";
import ReviewAndSignBase from "../shared/ReviewAndSign/ReviewAndSignBase";
import { getProducerFlowVerticalStepperElements } from "../../constants/ProducerFlowVerticalStepperElementsFactory";
import { GeaoContext } from "../../GeaoContextProvider";
import { ClientConfigurationContext } from "../../../../context/ClientConfigurationContextProvider";

export default function ProducerReviewAndSign() {
    const { agentInterview } = useContext(GeaoContext);
    const clientConfiguration = useContext(ClientConfigurationContext);

    // Get the dynamic vertical stepper with offshore settings
    const enableOffshore = clientConfiguration?.enableOffshore === true;
    const isOffshoreResident = agentInterview?.questionAnswers?.OffshoreResident?.answer === "true";
    const verticalStepperElements = getProducerFlowVerticalStepperElements(enableOffshore, isOffshoreResident);

    return (
        <ReviewAndSignBase
            flowType={FlowType.Producer}
            verticalStepperElements={verticalStepperElements}
            currentStepperItem="Review and Sign"
            componentName="ProducerReviewAndSign"
        />
    );
}
